import React from 'react'
import PropTypes from 'prop-types'
import Skeleton from '../UI/Skeleton'

class TermsContent extends React.Component {
    constructor(props) {
        super(props)
        this.link = `/term/${this.props.id}`
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.props.skeleton ?
                        <div>
                            <div className="news-title md-font-size"><Skeleton width={'30%'} /></div>
                            <div className="news-desc md-font-size"><Skeleton count={3} /></div>
                        </div>
                        :
                        <div>
                            <div className="news-title md-font-size">{this.props.name}</div>
                            <div className="news-desc md-font-size" dangerouslySetInnerHTML={{ __html: this.props.desc }}></div>
                        </div>
                }
            </React.Fragment>
        )
    }
}

TermsContent.propTypes = {
    id: PropTypes.number,
    name: PropTypes.string,
    desc: PropTypes.string,
    skeleton: PropTypes.bool,
}

export default TermsContent



// WEBPACK FOOTER //
// ./src/components/Terms/TermsContent.jsx